import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vants from '@/utils/vant.tuil'
import { loading } from '@/utils/common.util'
import filters from '@/libs/display/filters'
import directives from '@/libs/display/directives'
import 'vant/lib/index.less'
import '@/assets/global.less'
import '@/monitor.init'

vants.forEach(v => Vue.use(v))

Vue.config.productionTip = false
Vue.prototype.$loading = loading

// 批量导入 filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 批量导入指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
